import { ContentRevealAnimation } from 'fitify-ui-landing/src/components/animations/ContentRevealAnimation'
import Container from 'fitify-ui-landing/src/components/Container/Container'
import Section from 'fitify-ui-landing/src/components/Section/Section'
import { Text } from 'fitify-ui-landing/src/components/Text'
import { useTranslation } from 'next-i18next'

import { Review } from '@/components/blocks/Reviews/Review'
import {
  StyledContainer,
  StyledReviewsContainer,
} from '@/components/blocks/Reviews/Reviews.Styled'
import { reviewsData } from '@/data/reviews'

export const Reviews = () => {
  const { t } = useTranslation()

  return (
    <Section id="reviews">
      <ContentRevealAnimation>
        <StyledContainer>
          <Container>
            <Text
              as="h2"
              variant="business-title"
              style={{ textAlign: 'center' }}
            >
              {t('landing_review_block_headline')}
            </Text>
          </Container>

          <StyledReviewsContainer>
            {reviewsData.map((item, index: number) => {
              return <Review key={index} {...item} />
            })}
          </StyledReviewsContainer>
        </StyledContainer>
      </ContentRevealAnimation>
    </Section>
  )
}
